export default "__VITE_ASSET__P5e2DO1j__"